import dayjs from "dayjs";
import { formatDuration } from "utils/formaters";

interface IShootExecutionInfoCardProps {
  createdAt?: string;
  totalLeads?: number;
  executionTime?: number;
}

export function ShootExecutionInfoCard({
  createdAt,
  totalLeads = 0,
  executionTime,
}: IShootExecutionInfoCardProps) {
  return (
    <div
      style={{
        backgroundColor: "#FAFAFA",
        border: "1px solid #E2E2E2",
        borderRadius: 4,
        padding: 16,
      }}
    >
      <div style={{ display: "flex", gap: "2rem", flexWrap: "wrap" }}>
        <div>
          <h4>Data do Upload</h4>
          <span>
            {createdAt
              ? dayjs(createdAt).format("DD/MM/YYYY")
              : dayjs().format("DD/MM/YYYY")}
          </span>
        </div>

        <div>
          <h4>Tamanho da base de lead</h4>
          <span>
            {totalLeads ? Intl.NumberFormat("pt-BR").format(totalLeads) : "--"}
          </span>
        </div>

        <div>
          <h4>Tempo de execução do disparo</h4>
          <span>{executionTime ? formatDuration(executionTime) : "--"}</span>
        </div>
      </div>
    </div>
  );
}
